<template>
  <div class="ems-header-column field-col" :style="styleObject">
    <div class="content" @click="hanleClick">
      <div class="label-text-2">{{headerObject.displayName}}</div>
      <div class="icon-sort" v-if="showIcon" :class="[getIconClassName]"></div>
    </div>
    <div v-if="showResizeLine" class="resize-line"></div>
  </div>
</template>

<script>
  // import routerConstants from '@/router/constants';

  export default {
    name: 'c-header-column',
    props: {
      headerObject: {
        type: Object,
        required: true
      },
      sortObject: {
        type: Object,
        required: true
      },
      showIcon: {
        type: Boolean,
        default: true
      },
      showResizeLine: {
        type: Boolean,
        default: true
      },
      styleObject: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        urlConsts: '',
        sortReverse: false
      };
    },
    methods: {
      hanleClick () {
        this.sortReverse = !this.sortReverse;
        let sortOption = {
          fieldName: this.headerObject.internalName,
          sortReverse: this.sortReverse
        };
        this.$emit('CHANGE_SORT_OPTION', sortOption);
      }
    },
    computed: {
      getIconSort () {
        let iconName = 'sort-solid.svg';
        if (this.sortObject.fieldName === this.headerObject.internalName) {
          iconName = this.sortObject.reverse ? 'sort-up-solid.svg' : 'sort-down-solid.svg';
        }
        return `url('/static/images/${iconName}') no-repeat center`;
      },
      getIconClassName () {
        let className = 'non-sort';
        if (this.sortObject.fieldName === this.headerObject.internalName) {
          className = this.sortObject.reverse ? 'sort-up' : 'sort-down';
        }
        return className;
      }
    }
  };
</script>




// WEBPACK FOOTER //
// HeaderColumnEMS.vue?01abcc6b